import { Component, computed, inject } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { ImageModule } from 'primeng/image';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { BrandingService } from '../../_core/branding.service';
import { Core } from '../../_core/core';
import { ToastService } from '../../_core/toast.service';
import { Spinner } from '../../_core/spinner';
import { parseLocalizedAmount } from '../../utils/parse-localized-amount';

@Component({
  selector: 'app-add-building',
  imports: [
    ButtonModule,
    CardModule,
    CarouselModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    ImageModule,
    FloatLabelModule,
    MessageModule,
    ReactiveFormsModule,
  ],
  templateUrl: './add-building.html',
  styleUrl: './add-building.scss',
})
export class AddBuilding {
  private $core = inject(Core);
  private $branding = inject(BrandingService);
  private location = inject(Location);
  private formBuilder = inject(FormBuilder);
  private $toast = inject(ToastService);
  private $spinner = inject(Spinner);

  public form: FormGroup = this.initForm();
  public msgError: string = '';

  private readonly imageTitles = [
    'Datos del agua',
    'Detalles agua 2',
    'Datos de calefacción',
  ] as const;

  public readonly images = computed(() =>
    this.$branding.registrationImages().map((src, index) => ({
      src,
      title: this.imageTitles[index] ?? '',
    })),
  );

  private initForm(): FormGroup {
    return this.formBuilder.group({
      liquidationCode: [null, Validators.required],
      liquidationAmount: [null, Validators.required],
    });
  }

  public async submit(): Promise<void> {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const liquidationAmount = parseLocalizedAmount(this.form.value.liquidationAmount);
    if (liquidationAmount === null) {
      this.msgError = 'No se ha podido registrar la propiedad';
      return;
    }
    this.msgError = '';
    this.$spinner.show();
    try {
      const isSended = await this.$core.addTenantBuilding({
        liquidationCode: this.form.value.liquidationCode,
        liquidationAmount,
      });

      if (!isSended) {
        this.msgError = 'No se ha podido registrar la propiedad';
        return;
      }

      try {
        await this.$core.fetchBuildings(true);
      } catch (error) {
        console.error('Fetch buildings error:', error);
      }
      this.$toast.success('Propiedad registrada');
    } catch {
      this.msgError = 'No se ha podido registrar la propiedad';
    } finally {
      this.$spinner.hide();
    }
  }

  public goBack(): void {
    this.location.back();
  }
}
